import { render } from "./ApprovalWorkspacePage.vue?vue&type=template&id=19008699&scoped=true"
import script from "./ApprovalWorkspacePage.vue?vue&type=script&lang=js"
export * from "./ApprovalWorkspacePage.vue?vue&type=script&lang=js"

import "./ApprovalWorkspacePage.vue?vue&type=style&index=0&id=19008699&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19008699"]])

export default __exports__